const Partners = () => import('./Partners.vue')
const PartnerDetails = () => import('./PartnerDetails.vue')

export default [
  {
    name: 'partners',
    path: 'partners',
    component: Partners,
    meta: {
      access: ['org.partner.view']
    },
    children: [
      {
        name: 'partner-edit',
        path: ':partnerId/edit',
        components: {
          modal: PartnerDetails
        },
        meta: {
          showModal: true,
          access: ['org.partner.manage']
        }
      },
      {
        name: 'partner-details',
        path: ':partnerId/view',
        components: {
          modal: PartnerDetails
        },
        meta: {
          showModal: true,
          readOnly: true,
          access: ['org.partner.view']
        }
      },
      {
        name: 'partner-new',
        path: 'new',
        components: {
          modal: PartnerDetails
        },
        meta: {
          showModal: true,
          access: ['org.partner.manage']
        }
      }
    ]
  }
]
